(function () {
  'use strict';

  var FILTER_PARAMS = [
    'filter.p.product_type',
    'filter.p.m.homland.scene',
    'filter.p.m.homland.need',
    'filter.p.m.homland.bathroom_setup',
    'filter.p.m.homland.product_form',
    'filter.p.m.homland.support_features',
    'filter.p.m.homland.fit_support'
  ];

  var CLIENT_FILTERS = {
    'filter.p.product_type': 'hlProductType',
    'filter.p.m.homland.scene': 'hlScene',
    'filter.p.m.homland.need': 'hlNeed',
    'filter.p.m.homland.bathroom_setup': 'hlBathroom',
    'filter.p.m.homland.product_form': 'hlForm',
    'filter.p.m.homland.support_features': 'hlSupport',
    'filter.p.m.homland.fit_support': 'hlFit'
  };

  function bind(root) {
    if (!root || root.dataset.hlBathroomBound) return;
    root.dataset.hlBathroomBound = 'true';

    var history = ['start'];
    var selected = {};
    var questions = root.querySelectorAll('[data-hl-bathroom-question]');
    var result = root.querySelector('[data-hl-bathroom-result]');
    var progress = root.querySelector('[data-hl-bathroom-progress]');
    var progressFill = root.querySelector('[data-hl-bathroom-progress-fill]');
    var restartButtons = root.querySelectorAll('[data-hl-bathroom-restart], [data-hl-bathroom-result-restart]');
    var skip = root.querySelector('[data-hl-bathroom-skip]');
    var back = root.querySelector('[data-hl-bathroom-back]');
    var visuals = root.querySelectorAll('[data-hl-bathroom-visual]');

    function readUrlFilters() {
      var params = new URLSearchParams(window.location.search);
      selected = {};
      Object.keys(CLIENT_FILTERS).forEach(function (param) {
        params.getAll(param).forEach(function (value) { addFilter(param, value); });
      });
    }

    function cardMatches(card, param, values) {
      var raw = card.dataset[CLIENT_FILTERS[param]] || '';
      var cardValues = raw.split('|').map(function (value) { return value.trim().toLowerCase(); }).filter(Boolean);
      return values.some(function (value) { return cardValues.indexOf(value.trim().toLowerCase()) !== -1; });
    }

    function applyClientResultFilters() {
      var params = new URLSearchParams(window.location.search);
      var filters = {};
      Object.keys(CLIENT_FILTERS).forEach(function (param) {
        var values = params.getAll(param);
        if (values.length) filters[param] = values;
      });
      if (!Object.keys(filters).length) return;

      var grid = document.querySelector('.homland-prod-grid');
      if (!grid) return;
      var visible = 0;
      grid.querySelectorAll('.homland-p-card').forEach(function (card) {
        var matches = Object.keys(filters).every(function (param) { return cardMatches(card, param, filters[param]); });
        card.hidden = !matches;
        card.style.display = matches ? '' : 'none';
        if (matches) visible += 1;
      });
      var count = document.querySelector('[data-homland-result-count]');
      if (count) count.textContent = String(visible);
      var empty = document.querySelector('[data-homland-client-empty]');
      if (empty) empty.hidden = visible > 0;
    }

    function addFilter(param, value) {
      if (!param || !value) return;
      if (!selected[param]) selected[param] = [];
      if (selected[param].indexOf(value) === -1) selected[param].push(value);
    }

    function applyButtonFilters(button) {
      [
        [button.dataset.hlFilterParam, button.dataset.hlFilterValue],
        [button.dataset.hlFilterParam2, button.dataset.hlFilterValue2],
        [button.dataset.hlFilterParam3, button.dataset.hlFilterValue3]
      ].forEach(function (pair) {
        if (pair[0] === 'filter.p.m.homland.fit_support') selected[pair[0]] = [];
        addFilter(pair[0], pair[1]);
      });
    }

    function updateButtonCopy(button, copy) {
      var label = button.querySelector('span');
      var helper = button.querySelector('small');
      if (label) label.textContent = copy.label;
      if (helper) helper.textContent = copy.helper;
      button.dataset.hlFilterParam = copy.param;
      button.dataset.hlFilterValue = copy.value;
      button.hidden = false;
      button.setAttribute('aria-hidden', 'false');
    }

    function applyContextualOptions(target) {
      var question = root.querySelector('[data-hl-bathroom-question="' + target + '"]');
      if (!question) return;
      var scene = (selected['filter.p.m.homland.scene'] || [])[0] || '';
      var need = (selected['filter.p.m.homland.need'] || [])[0] || '';
      var copies = null;
      var needParam = 'filter.p.m.homland.need';
      var fitParam = 'filter.p.m.homland.fit_support';

      if (target === 'shower-space') {
        copies = [
          ['I feel unsteady while standing', 'Make room to sit and reset while washing.', needParam, 'Seated bathing'],
          ['There is very little room to move', 'Prioritize a compact fit for a smaller shower.', needParam, 'Narrow spaces'],
          ['I need to sit for the whole routine', 'Take weight off your feet while you wash.', needParam, 'Seated bathing']
        ];
      } else if (target === 'shower-support') {
        if (need === 'Narrow spaces') {
          copies = [
            ['I need a compact place to sit', 'Keep seated support without crowding the shower.', fitParam, 'Seated support'],
            ['I want back support in a small shower', 'Add support while keeping the footprint manageable.', fitParam, 'Back support'],
            ['I want to compare compact seated options', 'Review the seat and back support that fit the space.', fitParam, 'Seated support']
          ];
        } else if (need === 'Hand support') {
          copies = [
            ['I need support for my arms and hands', 'Keep a stable point of contact while washing.', fitParam, 'Hand support'],
            ['I want a backrest as well as hand support', 'Combine seated comfort with more upper-body support.', fitParam, 'Back support'],
            ['I want a supported place to sit', 'Choose seated support for a steadier routine.', fitParam, 'Seated support']
          ];
        } else {
          copies = [
            ['I need a simple place to sit', 'Keep the routine straightforward while washing.', fitParam, 'Seated support'],
            ['I want more support behind my back', 'Feel supported during a seated shower.', fitParam, 'Back support'],
            ['I need support for my arms and hands', 'Feel steadier while sitting and reaching.', fitParam, 'Hand support']
          ];
        }
      } else if (target === 'tub-hardest') {
        copies = [
          ['Stepping over the tub wall feels unsafe', 'Start the transfer from outside the tub.', needParam, 'Bathtub transfers'],
          ['Lowering down into the tub is difficult', 'Move into position with less strain.', needParam, 'Bathtub transfers'],
          ['I need to move across the tub edge seated', 'Keep the transfer supported while seated.', needParam, 'Bathtub transfers']
        ];
      } else if (target === 'tub-support') {
        copies = [
          ['I need support before entering the tub', 'Prepare outside the tub first.', fitParam, 'Transfer support'],
          ['I want to slide across instead of stepping over', 'Move across the tub edge while seated.', fitParam, 'Transfer support'],
          ['I need a stable point of contact during transfer', 'Keep the transfer steady from start to finish.', fitParam, 'Transfer support']
        ];
      } else if (target === 'toilet-hardest') {
        copies = [
          ['Lowering down or standing back up is hard', 'Make the seat height easier to manage.', needParam, 'Toilet sit-to-stand'],
          ['I need a steady place to hold beside the toilet', 'Add hand support to the toilet routine.', needParam, 'Toilet hand support'],
          ['I need support for both sitting and standing', 'Combine seat-height and hand-support needs.', needParam, 'Toilet sit-to-stand']
        ];
      } else if (target === 'toilet-support') {
        if (need === 'Toilet hand support') {
          copies = [
            ['I need stable handholds beside the toilet', 'Feel secure while sitting down and standing up.', fitParam, 'Hand support'],
            ['I want a higher seat with handholds', 'Support both parts of the toilet routine.', fitParam, 'Seat height + hand support'],
            ['I want to compare seat and rail support', 'Review height and hand support together.', fitParam, 'Height support']
          ];
        } else {
          copies = [
            ['I need a higher seat', 'Make sitting down and standing up easier.', fitParam, 'Height support'],
            ['I need stable handholds as well', 'Feel secure beside the toilet.', fitParam, 'Hand support'],
            ['I want a higher seat and handholds together', 'Support both parts of the routine.', fitParam, 'Seat height + hand support']
          ];
        }
      }

      if (!copies) return;
      question.querySelectorAll('[data-hl-bathroom-next], [data-hl-bathroom-submit]').forEach(function (button, index) {
        if (copies[index]) updateButtonCopy(button, {
          label: copies[index][0], helper: copies[index][1], param: copies[index][2], value: copies[index][3]
        });
      });
    }

    function visualFor(target) {
      if (target.indexOf('tub-') === 0) return 'tub';
      if (target.indexOf('toilet-') === 0) return 'toilet';
      return 'shower';
    }

    function show(target, isResult, shouldFocus) {
      questions.forEach(function (question) {
        var active = !isResult && question.dataset.hlBathroomQuestion === target;
        question.hidden = !active;
        question.classList.toggle('is-current', active);
      });

      var activeVisual = visualFor(target);
      visuals.forEach(function (visual) {
        var active = visual.dataset.hlBathroomVisual === activeVisual;
        visual.classList.toggle('is-current', active);
        visual.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      if (result) {
        result.hidden = !isResult;
        result.classList.toggle('is-current', isResult);
      }

      var activeQuestion = root.querySelector('[data-hl-bathroom-question="' + target + '"]');
      if (shouldFocus !== false) {
        var focus = isResult
          ? result && result.querySelector('[data-hl-bathroom-focus]')
          : activeQuestion && activeQuestion.querySelector('[data-hl-bathroom-focus]');
        if (focus) focus.focus();
      }

      var count = activeQuestion && activeQuestion.querySelector('.hl-scenario-router__question-count');
      var questionNumber = count ? parseInt(count.textContent, 10) : 1;
      if (progress) progress.textContent = isResult ? 'All questions complete' : 'Question ' + questionNumber + ' of 3';
      if (progressFill) progressFill.style.width = (isResult ? 100 : Math.min(100, Math.max(0, (questionNumber / 3) * 100))) + '%';
      if (back) back.hidden = history.length < 2;
      applyContextualOptions(target);
    }

    function syncResultSummary() {
      var summary = document.querySelector('[data-homland-quiz-result-summary]');
      var chips = document.querySelector('[data-homland-quiz-result-chips]');
      if (!summary || !chips) return;

      var params = new URLSearchParams(window.location.search);
      var labels = [
        ['filter.p.m.homland.scene', 'scene'],
        ['filter.p.m.homland.need', 'need'],
        ['filter.p.m.homland.fit_support', 'support']
      ].reduce(function (items, pair) {
        params.getAll(pair[0]).forEach(function (value) {
          if (items.indexOf(value) === -1) items.push(value);
        });
        return items;
      }, []);

      chips.innerHTML = '';
      labels.forEach(function (label) {
        var chip = document.createElement('span');
        chip.className = 'homland-quiz-result-summary__chip';
        chip.textContent = label;
        chips.appendChild(chip);
      });
      summary.hidden = labels.length === 0;
    }

    function buildResultsUrl() {
      var url = new URL(window.location.href);
      FILTER_PARAMS.forEach(function (param) { url.searchParams.delete(param); });
      Object.keys(selected).forEach(function (param) {
        selected[param].forEach(function (value) { url.searchParams.append(param, value); });
      });
      url.hash = 'product-list';
      return url.toString();
    }

    function submit(button) {
      if (button) applyButtonFilters(button);
      var current = history[history.length - 1];

      var resultsUrl = buildResultsUrl();
      var collectionSection = document.querySelector('[data-homland-collection-filters]');
      var productAnchor = document.getElementById('product-list');

      // Reuse the collection filter controller so client-only metafields are
      // applied to the existing product cards before scrolling to the results.
      if (collectionSection && typeof window.history.pushState === 'function') {
        window.history.pushState({ homlandBathroomQuiz: true }, '', resultsUrl);
        window.dispatchEvent(new Event('popstate'));
        syncResultSummary();
        show(current, true);
        window.setTimeout(function () {
          var liveAnchor = document.getElementById('product-list') || productAnchor;
          if (liveAnchor && typeof liveAnchor.scrollIntoView === 'function') {
            liveAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 120);
        return;
      }

      // Fallback for a minimal template without the collection controller.
      window.location.assign(resultsUrl);
    }

    root.querySelectorAll('[data-hl-bathroom-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (history.length === 1 && button.closest('[data-hl-bathroom-question="start"]')) selected = {};
        applyButtonFilters(button);
        history.push(button.dataset.hlBathroomNext);
        show(button.dataset.hlBathroomNext);
      });
    });

    root.querySelectorAll('[data-hl-bathroom-submit]').forEach(function (button) {
      button.addEventListener('click', function () { submit(button); });
    });

    if (skip) {
      skip.addEventListener('click', function () {
        var current = history[history.length - 1];
        var next = {
          'shower-space': 'shower-support',
          'tub-hardest': 'tub-support',
          'toilet-hardest': 'toilet-support'
        }[current];

        if (next) {
          history.push(next);
          show(next);
        } else {
          submit(null);
        }
      });
    }

    restartButtons.forEach(function (restart) {
      restart.addEventListener('click', function () {
        history = ['start'];
        selected = {};
        var resetUrl = new URL(window.location.href);
        FILTER_PARAMS.forEach(function (param) { resetUrl.searchParams.delete(param); });
        resetUrl.hash = '';
        window.history.pushState({ homlandBathroomQuiz: true }, '', resetUrl.toString());
        // Let the collection controller restore the complete product grid after
        // a filtered result state has been cleared.
        window.dispatchEvent(new Event('popstate'));
        syncResultSummary();
        show('start', false);
      });
    });

    if (back) {
      back.addEventListener('click', function () {
        if (history.length < 2) return;
        var current = history[history.length - 1];
        var currentQuestion = root.querySelector('[data-hl-bathroom-question="' + current + '"]');
        history.pop();
        // Remove filters chosen on the branch we are leaving so a revised
        // answer cannot be combined with a stale downstream condition.
        if (currentQuestion) currentQuestion.querySelectorAll('[data-hl-filter-param]').forEach(function (button) {
          if (button.dataset.hlFilterParam) delete selected[button.dataset.hlFilterParam];
          if (button.dataset.hlFilterParam2) delete selected[button.dataset.hlFilterParam2];
          if (button.dataset.hlFilterParam3) delete selected[button.dataset.hlFilterParam3];
        });
        show(history[history.length - 1]);
      });
    }

    readUrlFilters();
    applyClientResultFilters();
    syncResultSummary();

    var initialScene = (selected['filter.p.m.homland.scene'] || [])[0] || '';
    var initialNeed = (selected['filter.p.m.homland.need'] || [])[0] || '';
    var initialFit = (selected['filter.p.m.homland.fit_support'] || [])[0] || '';
    var initialResultTarget = {
      'Showering or bathing': 'shower-support',
      'Getting in or out of the bathtub': 'tub-support',
      'Using the toilet': 'toilet-support'
    }[initialScene];
    if (initialResultTarget && (initialNeed || initialFit)) {
      history = ['start', initialResultTarget];
      show(initialResultTarget, true, false);
    } else {
      show('start', false, false);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hl-bathroom-quiz]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
